import { Stack } from '@mui/material';
import { Box } from '@mui/material';
import { Typography } from 'components/elements';
import { useSelector } from 'store';
import { GetFileCommentsResponse } from 'types/image-viewer';
import { generalDateTimeFormat } from 'utils/date';

interface Props {
  comment: GetFileCommentsResponse;
}

const ImageViewerComment = ({ comment }: Props) => {
  const userName = useSelector((state) => state.auth?.decodedAuthToken?.unique_name);

  return (
    <Box className={`file-comment-card ${userName === comment.createBy ? 'self' : ''}`}>
      <Stack direction="row" justifyContent="space-between">
        <Typography sx={{ whiteSpace: 'pre' }}>{comment.comment}</Typography>
        <Box>
          <Stack alignItems="flex-end">
            <Typography variant="caption">{comment.createBy}</Typography>
            <Typography variant="caption">{generalDateTimeFormat(comment.createOn, { hideTime: true })}</Typography>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default ImageViewerComment;
